export const SEGMENT_SCREEN_PARAMS = {
  VEHICLE_SELECTION: {
    flow_step: 1,
    flow_stage: 'vehicle',
    screen_name: 'vehicle_selection',
    screen_title: 'Enter Your License Plate',
    field_count: 3,
    required_field_count: 3,
  },
  VEHICLE_SELECTION_MANUAL: {
    flow_step: 1,
    flow_stage: 'vehicle',
    screen_name: 'vehicle_selection',
    screen_title: 'Enter Your License Plate',
    field_count: 4,
    required_field_count: 4,
  },
  PROVE_IDENTITY: {
    flow_step: 2,
    flow_stage: 'identity',
    screen_name: 'prove_identity',
    screen_title: 'Prove Identity',
  },
  CONTACT_INFO: {
    flow_step: 3,
    flow_stage: 'contact',
    screen_name: 'contact_info',
    screen_title: 'Contact Information',
    field_count: 2,
    required_field_count: 2,
  },
  CONTACT_INFO_MANUAL: {
    flow_step: 3,
    flow_stage: 'contact',
    screen_name: 'contact_info',
    screen_title: 'Contact Information',
    field_count: 9,
    required_field_count: 8,
  },
  LOAN_DETAILS: {
    flow_step: 4,
    flow_stage: 'loan',
    screen_name: 'loan_details',
    screen_title: 'Current Loan Details',
    field_count: 1,
    required_field_count: 1,
  },
  LENDER_DETAILS: {
    flow_step: 4,
    flow_stage: 'lender',
    screen_name: 'lender_details',
    screen_title: 'Confirm Your Lender',
    field_count: 0,
    required_field_count: 0,
  },
  OFFERS: {
    flow_step: 5,
    flow_stage: 'offers',
    screen_name: 'offers',
    screen_title: 'Your Refinancing Offers',
    field_count: 0,
    required_field_count: 0,
  },
  OFFER_OFF_RAMP: {
    flow_step: 5,
    flow_stage: 'off_ramp',
    screen_name: 'off_ramp_call',
  },
  ADDRESS_LOOP: {
    flow_step: 6,
    flow_stage: 'address',
    screen_name: 'address_loop',
    screen_title: 'Add Your Address History',
  },
  EMPLOYMENT_LOOP: {
    flow_step: 7,
    flow_stage: 'employment',
    screen_name: 'employment_loop',
    screen_title: 'Employment History',
    field_count: 11,
    required_field_count: 9,
  },
  NEXT_STEPS: {
    flow_step: 8,
    flow_stage: 'next_steps',
    screen_name: 'post_submission_next_steps',
    screen_title: 'What\'s Next',
    checklist_items_total: 3,
  },
  THANK_YOU_PAGE: {
    flow_step: 9,
    flow_stage: 'complete',
    screen_name: 'thank_you',
    screen_title: 'Thank You',
  },
} as const;
